// extracted by mini-css-extract-plugin
export default {"timer":"P1-z","loaded":"Q1-z"};